import Counter from '../Counter';

const Demo6Statistic1 = () => {
    return (
        <div id="statistic-1" className="bg-01 pt-70 pb-70 statistic-section division">
            <div className="container white-color">
                <div className="statistic-1-wrapper">
                    <div className="row justify-content-md-center row-cols-1 row-cols-md-3">
                        <div id="sb-1-1" className="col">
                            <div className="statistic-block wow fadeInUp">
                                <h2 className="h2-xl statistic-number">
                                    <Counter end={28} />%
                                </h2>
                                <h5 className="h5-lg">Faster Delivery</h5>
                                <p className="p-lg">Automated workflows and integrations speed up time-to-market for new languages.</p>
                            </div>
                        </div>
                        <div id="sb-1-2" className="col">
                            <div className="statistic-block wow fadeInUp">
                                <h2 className="h2-xl statistic-number">
                                    <Counter end={54} />%
                                </h2>
                                <h5 className="h5-lg">Cost Savings</h5>
                                <p className="p-lg">Translation memory and AI assistance reduce costs by avoiding re-translating existing content.</p>
                            </div>
                        </div>
                        <div id="sb-1-3" className="col">
                            <div className="statistic-block wow fadeInUp">
                                <h2 className="h2-xl statistic-number">
                                    <Counter end={36} />%
                                </h2>
                                <h5 className="h5-lg">Quality Assurance</h5>
                                <p className="p-lg">Built-in review tools and glossaries ensure consistent, high-quality translations.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Demo6Statistic1;
